import { styled } from 'styled-components';

export const Container = styled.div`
  width: 100%;

  hr {
    margin: 0.9rem 0 0.6rem;
  }
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const InfoUser = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.1rem;
`;

export const FooterCard = styled.div`
  width: 100%;

  p {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.texts_light};
    margin: 0 0 0.6rem;
  }

  button {
    width: 100%;
  }
`;

export const ContainerActions = styled.div`
  display: flex;
  gap: 0.8rem;

  button:last-child {
    width: fit-content;
  }
`;
